module.exports = __webpack_public_path__ + "static/media/google-plus.15434e51.svg";